export default "__VITE_ASSET__BGOP888E__"